import { getProjectPerformance as getProjectPerformanceService } from "services/company/projectManagement/report/reportService";
import {
  getReportStart,
  getReportSuccess,
  getReportFailure,
} from "./reportSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch project performance report
export const fetchProjectPerformanceReport = (filtersData) => async (dispatch) => {
  try {
    dispatch(getReportStart());
    const response = await getProjectPerformanceService(filtersData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getReportSuccess(response.data));
      showSuccessToast(response?.meta?.message || "Report fetched successfully");
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch report";
      dispatch(getReportFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch report error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch report";
    dispatch(getReportFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
